export default function AlfieIcon() {
  return (
<svg width="24" height="28" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_dddd_8000_15590)">
<g clipPath="url(#clip0_8000_15590)">
<path d="M1 10C1 4.47715 5.47715 0 11 0C16.5228 0 21 4.47715 21 10C21 15.5228 16.5228 20 11 20C5.47715 20 1 15.5228 1 10Z" fill="#4272DD"/>
<g filter="url(#filter1_f_8000_15590)">
<circle cx="16.668" cy="10" r="8" fill="#D9D9D9"/>
</g>
<g filter="url(#filter2_ddi_8000_15590)">
<path d="M11 7C11.5143 8.38987 12.6101 9.4857 14 10C12.6101 10.5143 11.5143 11.6101 11 13C10.4857 11.6101 9.38987 10.5143 8 10C9.38987 9.4857 10.4857 8.38987 11 7Z" fill="white"/>
<path d="M11 7C11.5143 8.38987 12.6101 9.4857 14 10C12.6101 10.5143 11.5143 11.6101 11 13C10.4857 11.6101 9.38987 10.5143 8 10C9.38987 9.4857 10.4857 8.38987 11 7Z" fill="url(#paint0_linear_8000_15590)"/>
</g>
<g filter="url(#filter3_ddi_8000_15590)">
<path d="M7.66797 5.66602C7.8394 6.12931 8.20468 6.49458 8.66797 6.66602C8.20468 6.83745 7.8394 7.20272 7.66797 7.66602C7.49654 7.20272 7.13126 6.83745 6.66797 6.66602C7.13126 6.49458 7.49654 6.12931 7.66797 5.66602Z" fill="white"/>
<path d="M7.66797 5.66602C7.8394 6.12931 8.20468 6.49458 8.66797 6.66602C8.20468 6.83745 7.8394 7.20272 7.66797 7.66602C7.49654 7.20272 7.13126 6.83745 6.66797 6.66602C7.13126 6.49458 7.49654 6.12931 7.66797 5.66602Z" fill="url(#paint1_linear_8000_15590)"/>
</g>
</g>
<path d="M11 0.333008C16.3388 0.333008 20.667 4.66125 20.667 10C20.667 15.3388 16.3388 19.667 11 19.667C5.66125 19.667 1.33301 15.3388 1.33301 10C1.33301 4.66125 5.66125 0.333008 11 0.333008Z" stroke="#040404" strokeOpacity="0.05" strokeWidth="0.666667"/>  
</g>
<defs>
<filter id="filter0_dddd_8000_15590" x="1.78814e-07" y="0" width="22" height="23.6667" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.333333"/>
<feGaussianBlur stdDeviation="0.166667"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8000_15590"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="0.666667"/>
<feGaussianBlur stdDeviation="0.333333"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.13 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_8000_15590" result="effect2_dropShadow_8000_15590"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1.66667"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="effect2_dropShadow_8000_15590" result="effect3_dropShadow_8000_15590"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2.66667"/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.0666667 0 0 0 0 0.184314 0 0 0 0 0.411765 0 0 0 0.02 0"/>
<feBlend mode="normal" in2="effect3_dropShadow_8000_15590" result="effect4_dropShadow_8000_15590"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_8000_15590" result="shape"/>
</filter>
<filter id="filter1_f_8000_15590" x="-1.33203" y="-8" width="36" height="36" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_8000_15590"/>
</filter>
<filter id="filter2_ddi_8000_15590" x="1.46958" y="5.9116" width="19.0608" height="19.0608" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1.0884" operator="erode" in="SourceAlpha" result="effect1_dropShadow_8000_15590"/>
<feOffset dy="2.17681"/>
<feGaussianBlur stdDeviation="1.6326"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8000_15590"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1.6326" operator="erode" in="SourceAlpha" result="effect2_dropShadow_8000_15590"/>
<feOffset dy="5.44202"/>
<feGaussianBlur stdDeviation="4.08151"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_8000_15590" result="effect2_dropShadow_8000_15590"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8000_15590" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="-0.333333"/>
<feGaussianBlur stdDeviation="0.666667"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="normal" in2="shape" result="effect3_innerShadow_8000_15590"/>
</filter>
<filter id="filter3_ddi_8000_15590" x="0.137549" y="4.57761" width="15.0608" height="15.0608" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1.0884" operator="erode" in="SourceAlpha" result="effect1_dropShadow_8000_15590"/>
<feOffset dy="2.17681"/>
<feGaussianBlur stdDeviation="1.6326"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8000_15590"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1.6326" operator="erode" in="SourceAlpha" result="effect2_dropShadow_8000_15590"/>
<feOffset dy="5.44202"/>
<feGaussianBlur stdDeviation="4.08151"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_8000_15590" result="effect2_dropShadow_8000_15590"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8000_15590" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="-0.333333"/>
<feGaussianBlur stdDeviation="0.666667"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
<feBlend mode="normal" in2="shape" result="effect3_innerShadow_8000_15590"/>
</filter>
<linearGradient id="paint0_linear_8000_15590" x1="11" y1="7" x2="11" y2="13" gradientUnits="userSpaceOnUse">
<stop stopColor="#AAE4FD"/>
<stop offset="1" stopColor="#FFF2F2"/>
</linearGradient>
<linearGradient id="paint1_linear_8000_15590" x1="7.66797" y1="5.66602" x2="7.66797" y2="7.66602" gradientUnits="userSpaceOnUse">
<stop stopColor="#AAE4FD"/>
<stop offset="1" stopColor="#FFF2F2"/>
</linearGradient>
<clipPath id="clip0_8000_15590">
<path d="M1 10C1 4.47715 5.47715 0 11 0C16.5228 0 21 4.47715 21 10C21 15.5228 16.5228 20 11 20C5.47715 20 1 15.5228 1 10Z" fill="white"/>
</clipPath>
</defs>
</svg>
  )
}